module.exports = __webpack_public_path__ + "assets/img/wrap.75758123.png";